import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import { useNavigate } from "react-router-dom";

import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { createService } from "store/actions";
import { EditorComponent } from "components/shared/FormComponents";
import ImageUpdate from "components/shared/ImageUpdate";

const AddService = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedImage, setSelectedImage] = useState({
    preview: "",
    path: "",
  });
  const [description, setDescription] = useState("");
  const [selectedIcon, setSelectedIcon] = useState({
    preview: "",
    path: "",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    data.icon = selectedIcon.path;
    data.description = description;
    data.image = selectedImage.path;

    dispatch(
      createService({
        data,
        navigate,
        toast,
      })
    );
  };

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>اضافة خدمة جديدة</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={10} md={12}>
                <Row>
                  <Col lg={3} xs={12}>
                    <div className="form-group upload-contain required">
                      <h5>ايقونة الخدمة</h5>
                      <ImageUpdate
                        selectedImage={selectedIcon}
                        setSelectedImage={setSelectedIcon}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12} className="card-settings">
                    <div className="form-group required upload-cover">
                      <h5>صورة الخدمة</h5>
                      <ImageUpdate
                        selectedImage={selectedImage}
                        setSelectedImage={setSelectedImage}
                      />
                    </div>
                  </Col>
                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5>اسم الخدمة </h5>
                      <div>
                        <input
                          type="text"
                          className="form-control form-outline"
                          placeholder="اسم الخدمة "
                          {...register("title", { required: true })}
                        />
                      </div>
                      <p className="error-hint">
                        {errors?.title && "يرجي ادخال اسم الخدمة "}
                      </p>
                    </div>
                  </Col>

                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5>وصف</h5>
                      <div>
                        <EditorComponent
                          name="description"
                          setData={setDescription}
                          initialValue=""
                        />
                      </div>
                      <p className="error-hint">
                        {description === "" && "يرجي ادخال وصف الخدمة"}
                      </p>
                    </div>
                  </Col>
                  <Col lg={4} xs={12}>
                    <div className="form-group">
                      <button type="submit" className="btn btn-blue">
                        اضافة
                      </button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddService;
